import m, {type Children, MithrilComponent} from '@bitstillery/mithril'

import {Heading} from '../heading/heading'
import type {CmsComponentMeta} from '@bitstillery/common/cms/catalog_meta'

export const sectionMeta = {
    tier: 'layout',
    summary: 'A page section: an optional heading plus body content as children.',
    when_to_use: 'Group related content. A call-to-action is just a `<Button>` at the end of the body — there is no cta slot.',
    example: `
    <Section title="Popular categories">
        <Grid min="16rem">
            <Card image="/common/img/catalog/example-placeholder.jpg" title="Whisky" />
        </Grid>
    </Section>
    `,
} satisfies CmsComponentMeta

export interface SectionAttrs {
    /** Optional section heading (rendered as a level-2 `Heading`, styled consistently). */
    title?: Children
}

/**
 * A page section: optional heading + body content. A CTA is just a `<Button>` placed at the end of
 * the body — there is no separate cta slot. For a recessed surface, wrap the body in a `Well`.
 */
export class Section extends MithrilComponent<SectionAttrs> {
    view(vnode: m.Vnode<SectionAttrs>) {
        return (
            <section className='cms-section'>
                {vnode.attrs.title ? m(Heading, {level: 2}, vnode.attrs.title) : null}
                {vnode.children}
            </section>
        )
    }
}
